<template>
  <section v-if="days && Object.keys(days).length">
    <el-row
      v-for="(d, price) in days"
      :key="price"
      type="flex"
      align="top"
      class="day-info"
    >
      <el-col :span="12" :class="{ current: choosed, dayChoose: true }">
        <span class="dayTitle">
          <b>{{ choosed ? 'Выбранная дата:' : 'Даты погрузок:' }}</b>
        </span>
        <span v-if="d.dates.length">
          <span v-for="(date, i) in d.dates" :key="i">
            <b>
              {{ prepareDate(date, i, d.dates.length) }}
            </b>
          </span>
        </span>
        <span v-else>нет будующих</span>
      </el-col>
      <el-col :span="12" class="subscribe">
        <p>
          Цена:
          <br />
          <span class="price-vip">
            <span v-if="d.priceType"> {{ d.priceType }}<br /> </span>
            <b>{{ d.priceText }}</b>
          </span>
          <span v-if="d.priceText2" class="price-vip">
            <span v-if="d.priceType2"> {{ d.priceType2 }}<br /> </span>
            <b>{{ d.priceText2 }}</b>
          </span>
        </p>
      </el-col>
    </el-row>
  </section>
</template>

<script>
export default {
  name: 'DayInfo',
  props: {
    days: {
      type: Object,
      default: () => {},
    },
    choosed: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    prepareDate(date, i = 0, length = 1) {
      const arr = date.split('-')
      const sep = i + 1 < length ? ', ' : ''

      return `${arr[2]}.${arr[1]}${sep}`
    },
  },
}
</script>

<style lang="sass">
.dayChoose
  color: black!important
  display: flex
  flex-direction: column
  .dayTitle
    margin-bottom: 5px
</style>
